export const amplifyConfig = {
	Auth: {
		region: process.env.GATSBY_AWS_PROJECT_REGION,
		userPoolId: process.env.GATSBY_AWS_USER_POOLS_ID,
		userPoolWebClientId: process.env.GATSBY_AWS_USER_POOLS_WEB_CLIENT_ID,
	},
};
